<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper systemMessage" style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="modal systemMessage" style="top: 0;">
				<div class="modalContent">
					<div class="modalDecoration"></div>
					<div class="functionPanel unselectable">
						<a class="closeWindow clickable" @click="onModalClose(close)">
							<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
								<i class="action_cancel_tiny_flat_black"></i>
							</div>
						</a>
					</div>
					<div>
						<div class="contentHeader unselectable">
							<h2 class="msAntiScroll drag" draggable="true">
								<span class="building"><span>Плановые тех. работы 15-го февраля</span></span>
							</h2>
						</div>
					</div>
					<div class="heightTransitionContent">
						<div class="contentTabulation">
							<div class="tabulationContent scrollable scrollingDisabled">
								<div class="scrollContentOuterWrapper disableScrolling">
									<div class="scrollContent disableScrolling">
										<div class="scrollContentInnerWrapper">
											<div ng-transclude="">
												<div ng-controller="systemMessageCtrl">
													<div ng-bind-html="systemMessage">
														<a href="https://discord.gg/traviankingdoms" target="_blank"><img src="https://blog.kingdoms.com/wp-content/uploads/2023/11/RU_Lobby_Planned-maintenance.jpg" data-cmp-info="10"></a><br><br>Дорогие игроки!<br><br><div><b>В четверг, 15-го февраля, между 11:00 и 12:00 по МСК</b>, будут проводиться <b>плановые тех. работы</b>, во время которых будет перерыв в игровых мирах, лобби и на стартовой странице. ⚙️</div><br>Пожалуйста, заранее позаботьтесь о поставках зерна.<br><br>Больше новостей в <a href="https://discord.gg/traviankingdoms" target="_blank"><b>Discord</b></a>.<br><br>Благодарим за понимание!<br>Ваша команда Travian Kingdoms<br><br>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="window-overlay"></div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>